import meituanImageUrl from "@shared/core/meituanImageUrl";

export function processProductImages(product) {
  const imageInfos = {};
  const imageProcessor = {
    w: 400,
    h: 300,
    e: 1,
    c: 1,
    Q: 80,
    ext: "jpg",
  };
  if (product.coverImage) {
    imageInfos.coverImage = meituanImageUrl(product.coverImage, imageProcessor);
  }
  if (product.productImages) {
    imageInfos.productImages = product.productImages.map(url => meituanImageUrl(url, imageProcessor));
  }
  if (product.productMediaInfoList) {
    imageInfos.productMediaInfoList = product.productMediaInfoList.map(mediaInfo => ({
      ...mediaInfo,
      mediaUrl: meituanImageUrl(mediaInfo.mediaUrl, imageProcessor),
    }));
  }
  return imageInfos;
}

// 处理一下地址不展示的东西
export function processAddrees(product, { locationLatitude, locationRadius } = {}) {
  // 默认展示当前房源所在商区
  let addressInfo = {};
  if (locationLatitude || locationRadius) {
    addressInfo = {
      locationArea: null,
    };
  } else if (product.distanceDesc) {
    addressInfo = {
      locationArea: null,
    };
  }
  return addressInfo;
}

export function processProduct(product, { locationLatitude, locationRadius } = {}) {
  return {
    ...product,
    ...processAddrees(product, { locationLatitude, locationRadius }),
    ...processProductImages(product),
  };
}
